var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
/* eslint-disable react/jsx-no-bind */
import { useHistory, useLocation } from 'react-router-dom';
import * as React from 'react';
import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import { useLocalization } from '@shared-ui/localization-context';
import { UitkBreadcrumbs } from 'uitk-react-breadcrumbs';
import { UitkSpacing } from 'uitk-react-spacing';
import { LinkTracked } from '../../../../utils/click-trackers';
import { useStores } from '../../../../utils/hooks';
import { getBreadcrumbUrl } from '../../../../helpers/activity-search-helper';
export var Breadcrumbs = function () {
  var activitySearchStore = useStores().activitySearchStore;
  var formatText = useLocalization().formatText;
  var _a = __read(React.useState(false), 2),
    showMenu = _a[0],
    setShowMenu = _a[1];
  var searchSummary = activitySearchStore.searchSummary;
  var history = useHistory();
  var location = useLocation();
  var breadcrumbs = searchSummary && searchSummary.aboveTheFold && searchSummary.aboveTheFold.breadcrumbs;
  if (!breadcrumbs || breadcrumbs.length === 0) {
    return null;
  }
  var onClick = function () {
    activitySearchStore.searchSetup();
  };
  var crumbsContent = breadcrumbs.map(function (breadcrumb, index) {
    var _a, _b;
    return breadcrumb.selectionsToRemove.length > 0 ? React.createElement(LinkTracked, {
      key: index,
      linkName: (_a = breadcrumb.analytics) === null || _a === void 0 ? void 0 : _a.linkName,
      rfrr: (_b = breadcrumb.analytics) === null || _b === void 0 ? void 0 : _b.referrerId,
      to: getBreadcrumbUrl(history, location, breadcrumb.selectionsToRemove),
      "data-testid": "breadcrumb-link",
      onClick: onClick
    }, breadcrumb.label) : React.createElement(React.Fragment, null, React.createElement("span", {
      "aria-hidden": "true"
    }, breadcrumb.label), React.createElement("span", {
      className: "is-visually-hidden"
    }, "".concat(formatText('lx.search.breadcrumbs.currentpage', breadcrumb.label))));
  });
  return React.createElement(UitkSpacing, {
    margin: {
      blockend: 'three'
    }
  }, React.createElement("section", {
    "data-testid": "breadcrumbs--section"
  }, React.createElement(Viewport, null, React.createElement(ViewLarge, null, React.createElement(UitkBreadcrumbs, {
    crumbs: crumbsContent,
    hasDynamicInlineCrumbs: true,
    isOpen: showMenu,
    onTriggerClick: setShowMenu.bind(null, !showMenu)
  })), React.createElement(ViewSmall, null, React.createElement(UitkBreadcrumbs, {
    crumbs: crumbsContent,
    hasDynamicInlineCrumbs: false,
    isOpen: showMenu,
    onTriggerClick: setShowMenu.bind(null, !showMenu)
  })))));
};